import { render, staticRenderFns } from "./ajukaninbound.vue?vue&type=template&id=252bf722&scoped=true&"
import script from "./ajukaninbound.vue?vue&type=script&lang=js&"
export * from "./ajukaninbound.vue?vue&type=script&lang=js&"
import style0 from "./ajukaninbound.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ajukaninbound.vue?vue&type=style&index=1&id=252bf722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252bf722",
  null
  
)

export default component.exports